var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('loading'):[_c(_vm.$route.params.league.toUpperCase(),{tag:"component",attrs:{"league":_vm.league}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }